import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  drawer: {
    display: "flex",
    width: "100%",
    paddingTop: spacing.l,
  },
  left: {
    flexGrow: 1,
    marginLeft: spacing.l,
    marginRight: spacing.l,
  },
  right: {
    flexShrink: 0,
    marginTop: spacing.l,
    marginLeft: spacing.l,
    marginRight: spacing.l,
    alignSelf: "flex-start",
  },
};
